import React, { useEffect, useState } from 'react';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { ENTITY_PLURAL_LABEL } from '../../Helpers/Labels/EntityLabel';

const RecommendationFilterMultiSelect = (props) => {

    const [field, setField] = useState(null);
    let handler;
    useEffect(() => {
        if (field && props.value !== undefined && props.value !== null) {
            window.addEventListener("click", handleEnter);
        }
    }, [field, props])

    function handleEnter(event) {
        const isClickedOutside = field && field._input && event.type === "click" && !field._input.contains(event.target);
        if (isClickedOutside) {
            const tags = [...field.value];
            const inputValue = field._input.value.trim();
            if (inputValue && inputValue.length > 0) {
                const isTagUsed = tags.some(tag => tag.name.toLowerCase().trim() === inputValue.toLowerCase());
                if (!isTagUsed) {
                    tags.push({ name: inputValue });
                }
                field.setState(prevValue => ({
                    ...prevValue,
                    text: ""
                }));
                props.onChange({
                    target: {
                        name: props.name,
                        value: tags
                    }
                })
            }
        }
    }

    // show red tag in multiselect if 
    // item has hasNoMatch set to true
    // else green
    const itemRender = (tagData, li) => {
        return React.cloneElement(li, {
            ...li.props,
            className: {
                ...li.props.className,
                'match-found-tag': !tagData.data[0].hasNoMatch,
                'no-match-found-tag': tagData.data[0].hasNoMatch,
            }
        }, [
            <span key={tagData.data[0].name}>
                <i
                    className={
                        tagData.data[0].hasNoMatch ?
                            'fa-solid fa-xmark' : 'fa-solid fa-check'
                    } />
                &nbsp;
                {tagData.data[0].name.substring(0, 23)}
                {tagData.data[0].name.length > 23 && "..."}
            </span>
        ], li.props.children);
    }

    return (
        <div className='w-100'>
            <div className="custom-tag" >
                <MultiSelect
                    placeholder={`Type in ${ENTITY_PLURAL_LABEL} you want to include in your app and press enter while you finish typing.`}
                    ref={setField}
                    allowCustom={true}
                    data={[]}
                    textField="name"
                    value={props.value}
                    onChange={props.onChange}
                    dataItemKey="name"
                    tagRender={itemRender}
                    listNoDataRender={() => { }}
                    disabled={props.disabled}
                    popupSettings={{
                        height: 0
                    }}
                    onClose={(event) => {
                        const { value } = event?.target?._input;
                        if (value) {
                            // add new value to the list
                            // if it is not already there
                            if (props.value.find(item => item.name === value)) {
                                return;
                            }
                            props.onChange({
                                target: {
                                    value: [...props.value, { name: value }]
                                }
                            });
                            event.target.setState({ text: '' });
                        }
                    }}
                />
            </div>
        </div>
    );
}

export default RecommendationFilterMultiSelect;
